module.exports = __webpack_public_path__ + "assets_app/img/key-9.54cb5dbb.svg";